/* tslint:disable:max-line-length */
import {UntilDestroy} from '@ngneat/until-destroy';
import {Injectable} from '@angular/core';
import {FaultsImportService} from '../../faults-import.service';
import {TranslateService} from '@ngx-translate/core';
import {MydocmaDatePipe, MydocmaNumberPipe} from '@mydocma/common';
import {CellValidationResult} from '../common/cell-validate-import.result';
import {HttpClient} from '@angular/common/http';
import {ConfigService} from '@docma-mm-core/config/config.service';
import {map} from 'rxjs/operators';
import {catchError} from 'rxjs';
import {BaseImportService} from './base-import.service';

@UntilDestroy()
@Injectable()
export class ValidateImportService extends BaseImportService {

  constructor(protected faultsImportService: FaultsImportService,
              protected translateService: TranslateService,
              protected datepipe: MydocmaDatePipe,
              protected numberpipe: MydocmaNumberPipe,
              protected http: HttpClient,
              protected configService: ConfigService) {

    super(faultsImportService, translateService, datepipe, numberpipe, http, configService);
  }

  public async validateImportFile(selectedFile: { ImportFile: File | null; Files: string[] }, projectId: number): Promise<{[fieldName: string]: CellValidationResult}[]> {

    const url = super.getFullUrl(`/faults/import/validate`);

    const formData: FormData = new FormData();
    formData.append('File', selectedFile.ImportFile, selectedFile.ImportFile.name);
    formData.append('ProjectId', projectId.toString());
    selectedFile.Files.forEach(file => {
      formData.append('Attachments', file);
    });

    const response = await this.http.post<{[fieldName: string]: CellValidationResult}[]>(url, formData, { headers: this.getHeaders(true) })
      .pipe(
        map(data => {
          return data;
        }),
        catchError(e  => this.handleError(e)))
      .toPromise();

    return response;
  }

}
